module.exports = __webpack_public_path__ + "img/435-61c5e1.png";